module.exports = __webpack_public_path__ + "img/icon_bonus.b30644fa.svg";